import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import { useContext, useState } from 'react';
import UserProfile from './UserProfile';
import BillingPage from './BillingPage';
import { UserContext } from '../Context/UserContext';
import FeedbackPopup from '../Common/FeedbackPopup';
import FooterComponent from '../Common/FooterComponent';
import { sentryLog } from '../Utils/SentryLog';
import { getLqzyParams } from '../Utils/GetLqzyParams';
import ExtensionNavbar from './ExtensionNavbar';

const lemonSqzyQueryParams = getLqzyParams();

function SheetsExtensionUserAccount({isIndianUser}){

    const [category, setCategory] = useState("profile");
    const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);

    const { user } = useContext(UserContext);

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();
    const navigate = useNavigate();

    isShowConsole && console.log('user account user check ssrk: ', user);
    isShowConsole && console.log("Current Path:", location.pathname); 

    const API_BASE_URL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL;

    const initiateLogout = e => {
        try{
            window.location.href = `${API_BASE_URL}/auth/logout`;
        }catch(err){
            isShowConsole && console.error('error in initiate logout method: ', err);
            sentryLog(`SheetsExtensionUserAccount.js - initiateLogout failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const handleHelp = e => {
        try{
            navigate(`/sheets-extension-contact-us${lemonSqzyQueryParams}`);
        }catch(err){
            isShowConsole && console.error('error in handle help method: ', err);
            sentryLog(`SheetsExtensionUserAccount.js - handleHelp failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const openTextOcrAccountInfoPage = e => {
        try{
            window.open(
                'https://www.easyimagetotext.com/user-account',
                "_blank"
            );
        }catch(err){
            isShowConsole && console.error('error in openTextOcrAccountInfoPage method: ', err);
            sentryLog(`PricingPage.js - openTextOcrAccountInfoPage failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }
    
    return(
        <div className='parentDiv'>
            <div className='mainDiv userAccount'>
                <div className='header'>
                    <ExtensionNavbar />
                </div>
                <div className='contentDiv'>
                    <div className='containerDiv'>
                        <div className='title'>Account Information</div>
                        <div className='contentBox'>
                            <div className='content'>
                                <div className='lhs'>
                                    <div className='container'>
                                        <div className='top-section'>
                                            <div className={`category ${category === 'profile' ? 'selected' : ''}`} onClick={() => setCategory("profile")}>Profile Details</div>
                                            <div className={`category ${category === 'billing' ? 'selected' : ''}`} onClick={() => setCategory("billing")}>Billing Details</div>
                                        </div>
                                        <div className='bottom-section'>
                                            <div className='category' onClick={handleHelp}>Need Help ?</div>
                                            {/* <div className='category' onClick={initiateLogout}>Logout</div> */}
                                        </div>
                                    </div>
                                </div>
                                {user && <div className='rhs'>
                                    {category === 'profile' ? <UserProfile forSheetsExtension={true} userDetails={user}/> : category === "billing" ? <BillingPage forSheetsExtension={true} isIndianUser={isIndianUser} userDetails={user}/> : ""}
                                    <div className='userInfoNote'><b>NOTE:</b> These account details apply only to the Google Sheets Extension <b>Convert PDF to Google Sheets™</b></div>
                                </div>}
                                <div className='mobileBottomSection'>
                                    <div className='container'>
                                        <div className='category' onClick={handleHelp}>Need Help ?</div>
                                        {/* <div className='category' onClick={initiateLogout}>Logout</div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {showFeedbackPopup && <FeedbackPopup closeFeedbackPopup={() => setShowFeedbackPopup(false)}/>}
            </div>
            <FooterComponent forSheetsExtension={true} setShowFeedbackPopup={setShowFeedbackPopup}/>
        </div>
    )
}

export default SheetsExtensionUserAccount;